import React__default from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Alert } from '@sravni/react-design-system/lib/Alert';
import { Checkbox } from '@sravni/react-design-system/lib/Checkbox';
import { FormControl } from '@sravni/react-design-system/lib/FormControl';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { useStyles, mergeRefs } from '@sravni/react-utils';
import '../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../ContextProvider/components/IsLoadingProvider/hook.js';
import modules_13b53a7e from './styles.module.less.js';

const PATTERN = /\{([^{}]+)\}/g;
const SEPARATOR_PATTERN = /(\|)/;
const OPD_LINK = 'https://www.sravni.ru/promo/soglasie-na-obrabotku-personalnyh-dannyh/';
const ADVERTISING_LINK = 'https://f.sravni.ru/cms/file/FilePath/soglasie-na-poluchenie-reklamy.pdf';
const INPUT_NAME = "agreement" /* FIELD_NAME.AGREEMENT */;
const DEFAULT_TEXT = 'Даю согласие на {opdLink|обработку персональных данных} и {advertisingLink|получение рекламы}';
/** Компонент получения согласия на Перс данные и рекламу */
const AgreementCheckbox = React__default.forwardRef((props, ref) => {
    const { children = DEFAULT_TEXT, onBlur: onBlurOutside, onFocus: onFocusOutside, onChange: onChangeOutside, ...restProps } = props;
    const cx = useStyles(modules_13b53a7e);
    const { control, formState: { errors }, } = useFormContext();
    const [isLoading] = useIsLoading();
    const error = errors[INPUT_NAME];
    const childrenArray = children.split(PATTERN);
    return (React__default.createElement(FormControl, { invalid: !!error },
        React__default.createElement(Space, { direction: "vertical" },
            React__default.createElement(Controller, { name: INPUT_NAME, control: control, render: ({ field: { onBlur, onChange, ...field } }) => (React__default.createElement(Checkbox, { ...field, ...restProps, onBlur: (e) => {
                        onBlur();
                        onBlurOutside?.(e);
                    }, onChange: (e) => {
                        onChange(e);
                        onChangeOutside?.(e);
                    }, onFocus: onFocusOutside, checked: field.value, readOnly: isLoading, ref: mergeRefs(field.ref, ref) },
                    React__default.createElement("span", null, childrenArray.map((item) => {
                        const [key, _, value] = item.split(SEPARATOR_PATTERN);
                        switch (key) {
                            case 'opdLink':
                                return (React__default.createElement(Link, { key: OPD_LINK, href: OPD_LINK, target: "_blank" }, value));
                            case 'advertisingLink':
                                return (React__default.createElement(Link, { key: ADVERTISING_LINK, href: ADVERTISING_LINK, target: "_blank" }, value));
                            default:
                                return item;
                        }
                    })))) }),
            error?.message ? (React__default.createElement(Alert, { color: "red", className: cx('error') }, error.message)) : null)));
});

export { AgreementCheckbox };
//# sourceMappingURL=view.js.map
